export default "__VITE_ASSET__94bf4d6b__"